import React, { Component } from "react";
import { connect } from "react-redux";
import { AvForm, AvField } from "availity-reactstrap-validation";

import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
} from "reactstrap";
import Select from "react-select";
import { getMiniProductGroupsList } from "../../../store/Mini/actions";
import {
  InputChangeValue,
  SelecteChangeValue,
  ProductGroupAdd,
  model_close,
} from "../../../store/Masters/ProductGroups/actions";

class AddProductGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.ChangeHandeler = this.ChangeHandeler.bind(this);
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
  }
  componentDidMount() {
    this.props.getMiniProductGroupsList();
  }
  ChangeHandeler(e) {
    this.props.InputChangeValue({
      key: e.target.name,
      value: e.target.value,
    });
  }
  handleValidSubmit() {
    var data = this.props.rowdata;

    if (data.productcodeprefix == null) {
      // var errorLoc = "Select Location";
    } else {
      if (data.name == null) {
        // var errorSubLoc = "Enter Location";
      } else {
        var values = {
          id: data.id == null ? null : data.id,
          name: data.name,
          parent: data.ParentGroup_id,
          productcodeprefix: data.productcodeprefix,
        };

        this.props.ProductGroupAdd(values);
      }
    }
  }
  render() {
    var data = this.props.rowdata;
    return (
      <React.Fragment>
        <Modal isOpen={this.props.model} backdrop="static" centered size="lg">
          <ModalHeader toggle={() => this.props.model_close()}>
            ADD PRODUCT GROUPS
          </ModalHeader>
          <AvForm
            className="form-horizontal"
            onValidSubmit={this.handleValidSubmit}
          >
            <ModalBody>
              <Row className="justify-content-center">
                <Col md={10}>
                  <Row className="justify-content-center">
                    <Col md={9}>
                      <FormGroup row>
                        <Col md={5}>
                          <Label
                            htmlFor="Parent_Group_Select"
                            className="col-form-label float-right"
                          >
                            Select Parent Group
                          </Label>
                        </Col>
                        <Col md={7}>
                          <Select
                            id="Parent_Group_Select"
                            name="Parent_Group_Select"
                            classNamePrefix="select2-selection"
                            isClearable={
                              this.props.rowdata?.ParentGroupLabel
                                ? true
                                : false
                            }
                            options={this.props.miniPGroupList.map(
                              (item, index) => ({
                                label: item.name,
                                value: item.id,
                              })
                            )}
                            value={{
                              label:
                                data.ParentGroupLabel == null
                                  ? "Select Parent Group"
                                  : data.ParentGroupLabel,
                              value: data.ParentGroup_id,
                            }}
                            onChange={(e) => {
                              this.props.SelecteChangeValue({
                                key: "ParentGroupLabel",
                                label: e?.label,
                                key2: "ParentGroup_id",
                                value: e?.value,
                              });
                            }}
                          />
                        </Col>
                      </FormGroup>
                      {/* <FormGroup row>
                        <Col md={4}>
                          <Label
                            htmlFor="LocationName"
                            className="col-form-label float-right"
                          >
                            Product Prefix Code
                          </Label>
                        </Col>
                        <Col md={8}>
                          <AvField
                            name="name"
                            type="text"
                            value={data.name}
                            onChange={this.ChangeHandeler}
                            className="form-control"
                            id="LocationName"
                            placeholder="Enter Location Name"
                            errormessage=" Please provide a valid Location Name"
                            validate={{ required: { value: true } }}
                          />
                        </Col>
                      </FormGroup> */}
                      <FormGroup row>
                        <Col md={5}>
                          <Label
                            htmlFor="GroupName"
                            className="col-form-label float-right"
                          >
                            Product Prefix Code
                          </Label>
                        </Col>
                        <Col md={7}>
                          <AvField
                            name="productcodeprefix"
                            type="text"
                            className="form-control"
                            value={data.productcodeprefix}
                            onChange={this.ChangeHandeler}
                            id="productcodeprefix"
                            placeholder="Enter group Name"
                            errormessage=" Please provide a valid Group Name"
                            validate={{ required: { value: true } }}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Col md={5}>
                          <Label
                            htmlFor="GroupName"
                            className="col-form-label float-right"
                          >
                            Group Name
                          </Label>
                        </Col>
                        <Col md={7}>
                          <AvField
                            name="name"
                            type="text"
                            className="form-control"
                            value={data.name}
                            onChange={this.ChangeHandeler}
                            id="GroupName"
                            placeholder="Enter group Name"
                            errormessage=" Please provide a valid Group Name"
                            validate={{ required: { value: true } }}
                          />
                        </Col>
                      </FormGroup>
                      {/* <FormGroup>
                        <AvField
                          className="form-control"
                          type="hidden"
                          value={data.id}
                          id="id"
                          name="id"
                        />
                      </FormGroup> */}
                    </Col>
                  </Row>
                </Col>
              </Row>

              <ModalFooter>
                <Button
                  type="button"
                  className="btn btn-danger"
                  color="light"
                  onClick={() => this.props.model_close()}
                >
                  Close
                </Button>
                <Button
                  type="submit"
                  className="btn btn-primary"
                  color="primary"
                >
                  Save
                </Button>
              </ModalFooter>
            </ModalBody>
          </AvForm>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { miniPGroupList } = state.Mini;
  const { Sublocationlist, model, rowdata } = state.ProductGroup;
  return { miniPGroupList, Sublocationlist, model, rowdata };
};

export default connect(mapStatetoProps, {
  getMiniProductGroupsList,
  InputChangeValue,
  SelecteChangeValue,
  ProductGroupAdd,
  model_close,
})(AddProductGroup);
